import React, { useState } from 'react';
import SubscriptionManager from './SubscriptionManager';
import SubscriptionHealthWidget from './SubscriptionHealthWidget';
import PurchaseHistory from './PurchaseHistory';
import './SubscriptionPage.css';

/**
 * Dedicated Subscription / Membership page.
 *
 * Surfaces three things in one focused view:
 *   1. Current plan + renewal status (SubscriptionHealthWidget)
 *   2. Plan management (upgrade / downgrade / cancel) via SubscriptionManager
 *   3. Purchase + invoice history (PurchaseHistory)
 *
 * Mounted from the Courtyard "Subscription" sidebar tile so users can find
 * it without digging into Profile.
 */
const SubscriptionPage = ({ onBack, onUpgrade }) => {
  const [showHistory, setShowHistory] = useState(false);

  return (
    <div className="subscription-page" data-testid="subscription-page">
      <div className="subscription-page-inner">
        <button
          className="subscription-back-btn"
          onClick={onBack}
          data-testid="subscription-back-btn"
        >
          ← Back to Lobby
        </button>

        <header className="subscription-page-header">
          <div className="subscription-crest" aria-hidden="true">👑</div>
          <h1>Subscription &amp; Membership</h1>
          <p className="subscription-page-subtitle">
            Manage your plan, view renewals, and access your purchase history.
          </p>
        </header>

        <section className="subscription-page-section" aria-label="Current plan">
          <h2 className="subscription-page-section-title">Current plan</h2>
          <SubscriptionHealthWidget />
        </section>

        <section className="subscription-page-section" aria-label="Manage plan">
          <h2 className="subscription-page-section-title">Manage plan</h2>
          <SubscriptionManager onUpgrade={onUpgrade} />
        </section>

        <section className="subscription-page-section" aria-label="Purchase history">
          <h2 className="subscription-page-section-title">Purchase history</h2>
          <p className="subscription-page-history-hint">
            View every payment, subscription renewal, and skin purchase tied to your account.
          </p>
          <button
            type="button"
            className="subscription-history-btn"
            onClick={() => setShowHistory(true)}
            data-testid="subscription-history-btn"
          >
            View purchase history
          </button>
        </section>
      </div>

      {showHistory && (
        <PurchaseHistory onClose={() => setShowHistory(false)} />
      )}
    </div>
  );
};

export default SubscriptionPage;
